import { mutate } from "swr";

export async function globalMutate(cacheKey: string | string[]) {
  const keys = Array.isArray(cacheKey) ? cacheKey : [cacheKey];

  await Promise.all(
    keys.map((key) =>
      mutate(
        (swrKey) =>
          typeof swrKey === "string"
            ? swrKey === key
            : Array.isArray(swrKey) && swrKey[0] === key,
        undefined,
        { revalidate: true },
      ),
    ),
  );
}
